/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Division_MarketingInputs */

const en_mk_mock_division_marketing = /** @type {(inputs: Mk_Mock_Division_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

const id_mk_mock_division_marketing = /** @type {(inputs: Mk_Mock_Division_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

/**
* | output |
* | --- |
* | "Marketing" |
*
* @param {Mk_Mock_Division_MarketingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_division_marketing = /** @type {((inputs?: Mk_Mock_Division_MarketingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Division_MarketingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_division_marketing(inputs)
	return en_mk_mock_division_marketing(inputs)
});